import React, { useId } from "react";
import PropTypes from "prop-types";

const paths = [
  "M17.8059 14.8372C17.9223 14.9064 18.0659 14.9875 18.2286 15.0793C18.9414 15.4814 20.0189 16.0893 20.7571 16.8118C21.2188 17.2637 21.6574 17.8592 21.7372 18.5888C21.822 19.3646 21.4835 20.0927 20.8045 20.7396C19.633 21.8556 18.2272 22.75 16.4089 22.75H7.59068C5.77237 22.75 4.36658 21.8556 3.19514 20.7396C2.51612 20.0927 2.17766 19.3646 2.26246 18.5888C2.34221 17.8592 2.78086 17.2637 3.24253 16.8118C3.9807 16.0893 5.05821 15.4814 5.77102 15.0793C5.93368 14.9875 6.07737 14.9064 6.19368 14.8372C9.74772 12.7209 14.2519 12.7209 17.8059 14.8372Z",
  "M6.74981 6.5C6.74981 3.6005 9.10032 1.25 11.9998 1.25C14.8993 1.25 17.2498 3.6005 17.2498 6.5C17.2498 9.39949 14.8993 11.75 11.9998 11.75C9.10032 11.75 6.74981 9.39949 6.74981 6.5Z",
];

const UsersIcon = ({
  selected,
  width,
  height,
  className,
  ...props
}) => {
  const id = useId().replace(/:/g, "");
  const isActive = selected;
  const clipId = `users-clip-${id}`;
  const gradientIds = paths.map((_, index) => `users-gradient-${index}-${id}`);

  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <g opacity={isActive ? undefined : "0.5"}>
          {paths.map((path, index) => (
            <path key={path} d={path} fill={`url(#${gradientIds[index]})`} />
          ))}
        </g>
      </g>
      <defs>
        {gradientIds.map((gradientId) => (
          <linearGradient
            key={gradientId}
            id={gradientId}
            x1="20.4"
            y1="5.66516"
            x2="3.8885"
            y2="21.0921"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D946EF" />
            <stop offset="1" stopColor="#67E8F9" />
          </linearGradient>
        ))}
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

UsersIcon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

UsersIcon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default UsersIcon;
